var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('show-manual-pics',{attrs:{"fileNames":['13.png']}})}
var staticRenderFns = []

export { render, staticRenderFns }